import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import {
  isPhone,
  workerTypeStatusIconColor,
  workerTypeStatus,
  workerTypeStatusIconName,
  bytesToView,
  workerTypeStatusNames,
  secondsToView,
} from '../../../../../../../helpers';
import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

export default ({ connected, C, fileConnectorStatus, totalFiles, totalSize, totalBytesSentPerSecond, onlyMainBlock, dummy }) => {
  return connected ? (
    <View
      style={{
        height: scale(42),
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: scale(14),
        marginVertical: isPhone ? scale(7) : scale(12),
        opacity: dummy ? 0 : 1,
      }}
    >
      <Svg width={scale(25)} height={scale(25)} color={workerTypeStatusIconColor['updating']} icon={workerTypeStatusIconName['updating']} />
      <View
        style={{
          marginLeft: scale(10),
          flex: 1,
        }}
      >
        <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), width: '100%' }]} numberOfLines={1}>{`${i18n.t(
          'Syncing'
        )} ${totalFiles} ${i18n.t('Files...')}`}</Text>
        <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary') }]} numberOfLines={1}>
          {`${bytesToView(totalSize)} ${totalBytesSentPerSecond ? `(${secondsToView(totalSize / totalBytesSentPerSecond)}) ` : ''}${i18n.t(
            'remaining'
          )}`}{' '}
          {!onlyMainBlock && !isPhone && `∙ ${bytesToView(totalBytesSentPerSecond)}/${i18n.t('sec')}`}
        </Text>
      </View>
    </View>
  ) : (
    <StatusBlock {...{ status: fileConnectorStatus.status === workerTypeStatusNames.Online ? 'connecting' : fileConnectorStatus.status, C, dummy }} />
  );
};

const StatusBlock = ({ status, C, dummy }) => {
  return (
    <View
      style={{
        height: scale(42),
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: scale(14),
        marginVertical: isPhone ? scale(7) : scale(12),
        opacity: dummy ? 0 : 1,
      }}
    >
      <Svg width={scale(25)} height={scale(25)} color={workerTypeStatusIconColor[status]} icon={workerTypeStatusIconName[status]} />
      <View
        style={{
          marginLeft: scale(10),
          width: scale(190),
        }}
      >
        <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]} numberOfLines={1}>
          {i18n.t(workerTypeStatus[status])}
        </Text>
      </View>
    </View>
  );
};
